// Utils
import { isLine } from '../../../../common/elements/utils/elementTypeUtils';
import preventElementTypePredicate from './preventElementTypePredicate';

export default preventElementTypePredicate(isLine);
